package ch.wsl.box.client.utils

object ElementId {
  def tableRow(id:String):String = s"tableRow-$id"
}
